var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { styled } from '@mui/material';
import Box from '../Box';
import Typography from '../Typography';
;
var InfoTitleRoot = styled(Box)(function (_a) {
    var theme = _a.theme, beforeIcon = _a.beforeIcon;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 60,
        paddingLeft: theme.spacing(4.5),
        '&::before': __assign({}, (beforeIcon && {
            content: '""',
            display: 'inline-block',
            marginRight: 6,
            width: 2,
            height: 14,
            background: 'linear-gradient(360deg, #4bb051 0%, #5fc766 100%)'
        }))
    });
});
var InfoTitle = function (_a) {
    var title = _a.title, beforeIcon = _a.beforeIcon;
    return (React.createElement(InfoTitleRoot, { beforeIcon: beforeIcon },
        React.createElement(Typography, { variant: "h6", fontSize: 16, weight: "medium" }, title)));
};
export default InfoTitle;
